import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { CustomService } from "../../../services/api/custom/CustomService";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import InputMask from "react-input-mask";
import { Button, Select, Radio, Tag } from "antd";

import "./styles.scss";
import { CepService } from "../../../services/api/cep/CepService";
import { data } from "autoprefixer";

function RegisterOrcamentoForm({ userId }) {
  const {
  register,
  handleSubmit,
  control,
  reset,
  formState: { errors },
  setValue,
  watch,
} = useForm({
  defaultValues: {
    clienteId: "novo_cliente",
    aprovado: false,
    entregue: false,
    pago: false,
  },
});

const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [addOptionsComplete, setAddOptionsComplete] = useState([]);
  const [addOptions, setAddOptions] = useState([]);
  const [addingProducts, setAddingProducts] = useState([]);
  const [adding, setAdding] = useState(false);
  const [showPedido, setShowPedido] = useState(false);
  const [updatedPedido, setUpdatedPedido] = useState([]);
  const pedido = watch("pedido");
  const [telefone, setTelefone] = useState("");
  const [cep, setCep] = useState("");
  const [id, setId] = useState(null);
  const [selectedPriceType, setSelectedPriceType] = useState("A");

  // listas de clientes e vendedores
  const [clientesOptions, setClientesOptions] = useState([]);
  const [vendedoresOptions, setVendedoresOptions] = useState([]);
  const [depsLoading, setDepsLoading] = useState(true);

const clienteSelecionado = watch("clienteId");
const isNovoCliente = clienteSelecionado === "novo_cliente";
const clientePreenchido = !!clienteSelecionado && !isNovoCliente;
const vendedorId = watch("vendedorId");

useEffect(() => {
  const pedidoId = searchParams.get('id');
  if (pedidoId) {
    setValue("pedido", pedidoId);
    searchPedido(pedidoId);
  }
}, [searchParams]);


useEffect(() => {
  let tempVendedorId = vendedorId
  if (isNovoCliente) {
    reset({
      cliente: "",
      cnpj: "",
      clienteId: "novo_cliente",
      rua: "",
      numero: "",
      bairro: "",
      cidade: "",
      cep: "",
      prazo_entrega: "",
      cond_pagamento: "",
    });

    setValue("vendedorId", tempVendedorId || "sem_vendedor");
    setTelefone("");
    setCep("");
  }
}, [isNovoCliente, reset]);

  // carregar clientes e vendedores
  useEffect(() => {
    Promise.all([
      CustomService.getRequest("/interno/clientes"),
      CustomService.getRequest("/interno/vendedores"),
    ])
      .then(([clientes, vendedores]) => {
        const clientesFormatados = clientes.map(c => ({
          label: `${c.razao_social} (${c.cnpj})`,
          value: c.id
        }));
        setClientesOptions([
          { label: "🆕 Novo Cliente", value: "novo_cliente" },
          ...clientesFormatados
        ]);

        const vendedoresFormatados = vendedores.map(v => ({
          label: v.nome,
          value: v.id,
        }));
        setVendedoresOptions([
          { label: "Sem Vendedor", value: "sem_vendedor" }, //  Adiciona aqui
          ...vendedoresFormatados,
        ]);
      })
      .catch(() => toast.error("Erro ao carregar clientes ou vendedores"))
      .finally(() => setDepsLoading(false));
  }, []);

  const onSubmit = async (data) => {
    const requestData = updatedPedido.map((pedido) => ({
      fid_produto: pedido.fid,
      preco: pedido.precoA ? parseInt(Number(pedido.precoA) * 100) : 0,
      preco_b: pedido.precoB ? parseInt(Number(pedido.precoB) * 100) : 0,
      preco_c: pedido.precoC ? parseInt(Number(pedido.precoC) * 100) : 0,
      quantidade: pedido.quantidade ? parseInt(Number(pedido.quantidade)) : 0,
      tipo_preco: pedido.selectedPrice,
    }));

    let body = {
      id_pedido: id,
      telefone,
      cnpj: data.cnpj,
      cliente: data.cliente,
      produtos: requestData,
      logradouro: data.rua,
      numero: data.numero,
      cidade: data.cidade,
      cep,
      bairro: data.bairro,
      prazo_entrega: data.prazo_entrega,
      cond_pagamento: data.cond_pagamento,
      aprovado: data.aprovado,
      entregue: data.entregue,
      pago: data.pago,
    };
    // add cliente_id 
    if (data.clienteId !== "novo_cliente") {
      body = {
        ...body,
        cliente_id: data.clienteId,
      }
    }
    if (data.vendedorId !== "sem_vendedor") {
      body = {
        ...body,
        vendedor_id: data.vendedorId,
      }
    }

    try {
      const resp = await CustomService.postRequest("/interno/orcamento", body);
      toast.success("Orçamento gerado com sucesso!");
      reset();
      navigate(`/orcamentos`);
      if (resp.id) window.open(`https://api.foxsuprimentos.com.br/orcamento/${resp.id}/file`, "_blank");
    } catch {
      toast.error("Erro ao gerar orçamento.");
    }
  };

  // Autocomplete CEP
  useEffect(() => {
    const raw = cep.replace(/\D/g, "");
    if (raw.length === 8) {
      CepService.consultarCep(raw)
        .then(resp => {
          setValue("rua", resp.data.logradouro);
          setValue("cidade", resp.data.localidade);
        })
        .catch(() => toast.error("CEP inválido"));
    }
  }, [cep, setValue]);

  const capitalize = str => str ? str.charAt(0).toUpperCase()+str.slice(1).toLowerCase() : str;

  const cancel = () => {
  setShowPedido(false);
  setUpdatedPedido([]);
  setTelefone("");
  setCep("");
  setId(null);
  setSelectedPriceType("A");
  reset({
    clienteId: "novo_cliente",
    vendedorId: "sem_vendedor",
    cliente: "",
    cnpj: "",
    rua: "",
    numero: "",
    bairro: "",
    cidade: "",
    cep: "",
    prazo_entrega: "",
    cond_pagamento: "",
    pedido: "",
    aprovado: false,
    entregue: false,
    pago: false,
  });
};

const stockBadge = (raw) => {
  const estoque = Number(raw ?? 0);
  if (Number.isNaN(estoque)) return null;
  if (estoque <= 0) return <Tag color="red" style={{ marginLeft: 8 }}>Sem estoque</Tag>;
  if (estoque < 10) return <Tag color="gold" style={{ marginLeft: 8 }}>Baixo estoque</Tag>;
  return null; // >= 10 não mostra tag
};
  const deleteProduct = (index) => {
    const updated = [...updatedPedido];
    updated.splice(index, 1);
    setUpdatedPedido(updated);
  };

  const searchPedido = (resp) => {
  let fidPedido = resp ? resp : pedido;

  //  Primeiro busca o pedido para popular produtos
  CustomService.getRequest(`/interno/pedido/${fidPedido}`)
    .then((pedidoResp) => {
      setId(pedidoResp.id);

      const pedidos = pedidoResp.items?.map((item) => ({
        id: item.id,
        quantidade: item.quantidade,
        precoProdutoA: item.preco_produto ? item.preco_produto / 100 : 0,
        precoProdutoB: item.preco_produto_b ? item.preco_produto_b / 100 : 0,
        precoA: item.preco ? item.preco / 100 : item.preco_produto ? item.preco_produto / 100 : 0,
        precoB: item.preco_b ? item.preco_b / 100 : item.preco_produto_b ? item.preco_produto_b / 100 : 0,
        precoC: item.preco_c ? item.preco_c / 100 : item.preco_produto_c ? item.preco_produto_c / 100 : 0,
        nome: item.nome,
        tipo: item.tipo,
        imagem: item.imagem,
        fid: item.fid_produto,
        selectedPrice: item.tipo_preco ? item.tipo_preco : "A",
      }));
      setUpdatedPedido(pedidos ?? []);
      setShowPedido(true);

      //  Depois busca os dados do orçamento
      return CustomService.getRequest(`/interno/orcamento/${fidPedido}`);
    })
    .then((orcamento) => {
      setTelefone(orcamento.telefone || "");
      setCep(orcamento.cep || "");

      setValue("clienteId", orcamento.id_cliente ?? "novo_cliente");
      setValue("vendedorId", orcamento.id_vendedor ?? "sem_vendedor");
      setValue("cliente", orcamento.cliente || "");
      setValue("cnpj", orcamento.cnpj || "");
      setValue("rua", orcamento.logradouro || "");
      setValue("numero", orcamento.numero || "");
      setValue("bairro", orcamento.bairro || "");
      setValue("cidade", orcamento.cidade || "");
      setValue("prazo_entrega", orcamento.prazo_entrega || "");
      setValue("cond_pagamento", orcamento.cond_pagamento || "");
      setValue("aprovado", !!orcamento.aprovado_em);
      setValue("entregue", !!orcamento.entregue_em);
      setValue("pago", !!orcamento.pago_em);
    }).catch((error) => {
      // console.error("Erro ao buscar pedido ou orçamento:", error);
    })

  //  Carregar produtos
  CustomService.getRequest(`/interno/produtos`)
    .then((resp) => {
      const produtos = [];
      const produtosComplete = [];
      resp.forEach((produto) => {
        produtos.push({
          label: produto.nome,
          value: produto.fid,
        });
        produtosComplete.push({
          nome: produto.nome,
          fid: produto.fid,
          precoProdutoA: produto.preco_produto ? produto.preco_produto / 100 : 0,
          precoProdutoB: produto.preco_produto_b ? produto.preco_produto_b / 100 : 0,
          precoProdutoC: produto.preco_produto_c ? produto.preco_produto_c / 100 : 0,
          estoque: produto.estoque,
          tipo: produto.tipo,
          imagem: produto.imagem,
        });
      });
      setAddOptions(produtos);
      setAddOptionsComplete(produtosComplete);
    })
    .catch((error) => {
      toast.error("Erro ao buscar produtos");
    });
};

  const handlePriceAChange = (index, newPrice) => {
    const updated = [...updatedPedido];
    updated[index].precoA = newPrice;
    setUpdatedPedido(updated);
  };

  const handlePriceBChange = (index, newPrice) => {
    const updated = [...updatedPedido];
    updated[index].precoB = newPrice;
    setUpdatedPedido(updated);
  };

  const handlePriceCChange = (index, newPrice) => {
    const updated = [...updatedPedido];
    updated[index].precoC = newPrice;
    setUpdatedPedido(updated);
  };

  const handleQtChange = (index, newQt) => {
    const updated = [...updatedPedido];
    updated[index].quantidade = newQt;
    setUpdatedPedido(updated);
  };

  // Atualiza a seleção de preço individual para um item
  const handleItemPriceSelection = (index, value) => {
    const updated = [...updatedPedido];
    updated[index].selectedPrice = value;
    setUpdatedPedido(updated);
  };

  // Seletor global: ao alterar, atualiza todos os itens
  const handleGlobalPriceChange = (e) => {
    const value = e.target.value;
    setSelectedPriceType(value);
    const updated = updatedPedido.map((item) => ({
      ...item,
      selectedPrice: value,
    }));
    setUpdatedPedido(updated);
  };

// Função para carregar dados do cliente selecionado
const fetchClienteData = async (clienteId) => {
  try {
    const resp = await CustomService.getRequest(`/interno/cliente/${clienteId}`);
    const cliente = resp.data || resp; // ajuste conforme formato da resposta

    setValue("cliente", cliente.razao_social);
    setValue("cnpj", cliente.cnpj);
    setTelefone(cliente.telefone_contato || "");
    setCep(cliente.endereco?.cep || "");

    // se o endpoint retornar um objeto de endereço, ajuste conforme retorno:
    if (cliente.endereco) {
      setValue("rua", cliente.endereco.logradouro || "");
      setValue("numero", cliente.endereco.numero || "");
      setValue("bairro", cliente.endereco.bairro || "");
      setValue("cidade", cliente.endereco.cidade || "");
      setValue("cep", cliente.endereco.cep || "");
    }
  } catch (error) {
    console.error(error);
    toast.error("Erro ao carregar dados do cliente");
  }
};

  // Função para criar um novo pedido via POST na rota "/pedido"
const createPedido = async () => {
  try {
    const resp = await CustomService.postRequest("/pedido", {});
    toast.success("Pedido criado com sucesso!");
    setValue("pedido", resp);
    searchPedido(resp);
  } catch (error) {
    toast.error("Erro ao criar pedido.");
  }
};

  return (
    <div className="flex flex-col w-full gap-3">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3 w-full">
         {/* Depêndencias carregando */}
        {showPedido && depsLoading && <div>Carregando clientes e vendedores...</div>}

        {/* Seleções de cliente e vendedor */}
        {showPedido && !depsLoading && (
          <div className="flex gap-4">
            <div className="md:w-[30%]">
              <label>Cliente:</label>
                <Controller
                  name="clienteId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      loading={depsLoading}
                      showSearch
                      placeholder="Selecione o cliente"
                      options={clientesOptions}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        field.onChange(value);
                        if (value !== "novo_cliente") {
                          fetchClienteData(value);
                        }
                      }}
                    />
                  )}
                />

              {errors.clienteId && <p className="text-red-500">Selecione um cliente</p>}
            </div>

            <div className="md:w-[30%]">
              <label>Vendedor:</label>
              <Controller
                name="vendedorId"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    loading={depsLoading}
                    showSearch
                    placeholder="Selecione o vendedor"
                    options={vendedoresOptions}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                )}
              />
              {errors.vendedorId && <p className="text-red-500">Selecione um vendedor</p>}
            </div>
          </div>
        )}

        {/* Campos iniciais do formulário */}
        <div className="flex gap-4">
          <div className="md:w-[28.9%]">
            <label className="block mb-1">Número do Pedido:</label>
            <input
              type="text"
              className="border border-gray-300 p-2 w-full"
              {...register("pedido")}
              disabled={showPedido}
            />
            {errors.pedido && <p className="text-red-500 text-sm">{errors.pedido.message}</p>}
          </div>
        </div>

          
        {showPedido && (
          <div className="flex gap-4">
            <div className="w-1/3">
              <label>Cliente:</label>
                <input
                  type="text"
                  className={`border p-2 w-full ${
                    clientePreenchido
                      ? "bg-[#e5e7eb] text-[#9ca3af] border-[#d1d5db] cursor-not-allowed"
                      : "bg-white"
                  }`}
                  {...register("cliente", { required: "O nome do cliente é obrigatório" })}
                  disabled={clientePreenchido}
              />
              {errors.cliente && (
                <p className="text-red-500">{errors.cliente.message}</p>
              )}
            </div>

            <div className="w-1/3">
              <label>Telefone:</label>
              <InputMask
                mask="(99) 99999-9999"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
              >
                {(inputProps) => (
                  <input
                    type="text"
                    className="border border-gray-300 p-2 w-full"
                    {...inputProps}
                  />
                )}
              </InputMask>
            </div>

            <div className="w-1/3">
              <label>CNPJ:</label>
               <Controller
                name="cnpj"
                control={control}
                render={({ field }) => (
                  <InputMask
                    {...field}
                    mask="99.999.999/9999-99"
                    disabled={clientePreenchido}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {(inputProps) => (
                      <input
                        {...inputProps}
                        type="text"
                        className={`border p-2 w-full ${
                          clientePreenchido
                            ? "bg-[#e5e7eb] text-[#9ca3af] border-[#d1d5db] cursor-not-allowed"
                            : "bg-white"
                        }`}
                      />
                    )}
                  </InputMask>
                )}
              />
              {errors.cnpj && (
                <p className="text-red-500 text-sm">{errors.cnpj.message}</p>
              )}
            </div>
          </div>
        )}

        {showPedido && (
          <div className="flex gap-4">
            <div className="w-[15%]">
              <label>CEP:</label>
              <InputMask
                mask="99999-999"
                value={cep}
                onChange={(e) => setCep(e.target.value.replace(/\D/g, ""))}
              >
                {(inputProps) => (
                  <input
                    type="text"
                    className="border border-gray-300 p-2 w-full"
                    {...inputProps}
                  />
                )}
              </InputMask>
            </div>

            <div className="w-[45%]">
              <label>Rua:</label>
              <input
                type="text"
                className="border border-gray-300 p-2 w-full"
                {...register("rua")}
              />
            </div>

            <div className="w-[10%]">
              <label>Número:</label>
              <input
                type="text"
                className="border border-gray-300 p-2 w-full"
                {...register("numero")}
              />
            </div>

            <div className="w-[15%]">
              <label>Bairro:</label>
              <input
                type="text"
                className="border border-gray-300 p-2 w-full"
                {...register("bairro")}
              />
            </div>

            <div className="w-[15%]">
              <label>Cidade:</label>
              <input
                type="text"
                className="border border-gray-300 p-2 w-full"
                {...register("cidade")}
              />
            </div>
          </div>
        )}

        {showPedido && (
          <div className="flex gap-4">
            <div className="w-1/2">
              <label>Prazo de Entrega:</label>
              <input
                type="text"
                className="border border-gray-300 p-2 w-full"
                {...register("prazo_entrega")}
              />
              {errors.prazo_entrega && (
                <p className="text-red-500">{errors.prazo_entrega.message}</p>
              )}
            </div>

            <div className="w-1/2">
              <label>Condição de Pagamento:</label>
              <input
                type="text"
                className="border border-gray-300 p-2 w-full"
                {...register("cond_pagamento")}
              />
            </div>
          </div>
        )}

        {!showPedido && (
          <div className="flex mb-3 gap-2">
            <button
              type="button"
              onClick={() => searchPedido()}
              className="bg-blue-default text-white h-[35px] px-2 cursor-pointer text-[14px] rounded-[7px]"
            >
              Buscar Pedido
            </button>
            <button
              type="button"
              onClick={createPedido}
              className="bg-green-default text-white h-[35px] px-2 cursor-pointer text-[14px] rounded-[7px]"
            >
              Criar Pedido
            </button>
          </div>
        )}

        {showPedido && (
          <div className="md:w-[10%] mb-3">
            <Button
              style={{ backgroundColor: "#44ff44", color: "white" }}
              type="primary"
              onClick={() => setAdding(true)}
            >
              Adicionar Produto
            </Button>
          </div>
        )}

{showPedido && adding && (
  <>
    <div className="flex gap-3 w-full">
      <Select
        mode="multiple"
        allowClear
        style={{ width: "100%" }}
        placeholder="Selecione os produtos a adicionar"
        onChange={(value) => setAddingProducts(value)}
        optionFilterProp="label"
        optionLabelProp="label"
      >
        {addOptionsComplete.map((product) => {
          const estoque = Number(product.estoque ?? 0);
          const isLow = estoque > 0 && estoque < 10;
          const isEmpty = estoque <= 0;
          const stockColor = isEmpty ? "red" : isLow ? "orange" : "green";

          return (
            <Select.Option key={product.fid} value={product.fid} label={product.nome}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={product.imagem}
                    alt={product.nome}
                    style={{ width: 40, height: 40, objectFit: "contain", marginRight: 8 }}
                  />
                  <div>
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                      <span>{product.nome}</span>
                      {isEmpty && (
                        <Tag color="red" style={{
    marginLeft: 6,
    fontSize: 10,
    padding: "0 4px",
    height: 18,
    lineHeight: "16px",
    borderRadius: 4,
  }}>
                          Sem estoque
                        </Tag>
                      )}
                      {isLow && (
                        <Tag color="gold" style={{
    marginLeft: 6,
    fontSize: 10,
    padding: "0 4px",
    height: 18,
    lineHeight: "16px",
    borderRadius: 4,
  }}>
                          Baixo estoque
                        </Tag>
                      )}
                    </div>

                    <div style={{ fontSize: 12, color: "#888" }}>
                      Preço A: R$ {product.precoProdutoA.toFixed(2)}
                    </div>
                    <div style={{ fontSize: 12, color: "#888" }}>
                      Preço B: R$ {product.precoProdutoB.toFixed(2)}
                    </div>
                    <div style={{ fontSize: 12, color: "#888" }}>
                      Preço C: R$ {product.precoProdutoC.toFixed(2)}
                    </div>

                    {/* Estoque com número colorido */}
                    <div style={{ fontSize: 12, color: "#555", marginTop: 2 }}>
                      Estoque:{" "}
                      <span style={{ fontWeight: 600, color: stockColor }}>
                        {estoque}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Select.Option>
          );
        })}
      </Select>
    </div>

    <Button
      style={{ backgroundColor: "#44ff44", color: "white" }}
      type="primary"
      onClick={() => {
        const addedProducts = addingProducts.map((fid) => {
          const completeProduct = addOptionsComplete.find((opt) => opt.fid === fid);
          return {
            quantidade: 1,
            precoProdutoA: completeProduct.precoProdutoA,
            precoProdutoB: completeProduct.precoProdutoB,
            precoProdutoC: completeProduct.precoProdutoC,
            precoA: completeProduct.precoProdutoA,
            precoB: completeProduct.precoProdutoB,
            precoC: completeProduct.precoProdutoC,
            nome: completeProduct.nome,
            tipo: completeProduct.tipo
              ? completeProduct.tipo.charAt(0).toUpperCase() + completeProduct.tipo.slice(1)
              : "",
            imagem: completeProduct.imagem,
            fid: fid,
            selectedPrice: "A",
            estoque: Number(completeProduct.estoque ?? 0),
          };
        });

        let produtos = [...updatedPedido, ...addedProducts];
        produtos = produtos.filter(
          (p, i, self) => i === self.findIndex((t) => t.fid === p.fid)
        );
        setUpdatedPedido(produtos);
        setAdding(false);
      }}
    >
      Adicionar Produtos
    </Button>
  </>
)}


        {showPedido && (
          <>
            {/* Cabeçalho da listagem com larguras fixas */}
            <div className="flex gap-3 w-full border-b border-gray-300 pb-2">
              <div className="w-[15%]">
                <label className="block">Imagem:</label>
              </div>
              <div className="w-[25%]">
                <label className="block">Nome:</label>
              </div>
              <div className="w-[10%] flex items-center">
                <label className="block">Tipo:</label>
              </div>
              <div className="w-[10%] flex items-center">
                <label className="block">Quantidade:</label>
              </div>
              <div className="w-[10%] flex items-center">
                <label className="block">Preço A:</label>
              </div>
              <div className="w-[10%] flex items-center">
                <label className="block">Preço B:</label>
              </div>
              <div className="w-[10%] flex items-center">
                <label className="block">Preço C:</label>
              </div>
              <div className="w-[10%] flex items-center">
                <label className="block">Selecionar:</label>
              </div>
              <div className="w-[10%]">
                <label className="block">Excluir:</label>
              </div>
            </div>
            {updatedPedido.map((pedido, index) => (
              <div key={pedido.fid} className="flex gap-3 w-full border-b border-gray-300 py-2">
                <div className="w-[15%]">
                  <img
                    src={pedido.imagem}
                    alt={pedido.nome}
                    className="w-[100px] h-[100px] object-contain cursor-pointer"
                    onClick={() => window.open(pedido.imagem, "_blank")}
                  />
                </div>
                <div className="w-[25%]">
                  <div className="flex flex-col">
                    <span className="font-medium">{pedido.nome}</span>
                    <span className="text-sm text-gray-500">Preco Produto A: R$ {pedido.precoProdutoA.toFixed(2)}</span>
                    <span className="text-sm text-gray-500">Preco Produto B: R$ {pedido.precoProdutoB.toFixed(2)}</span>
                  </div>
                </div>
                <div className="w-[10%] flex items-center">
                  <span>{capitalize(pedido.tipo)}</span>
                </div>
                <div className="w-[10%] flex items-center">
                  <Controller
                    name={`quantidade_${pedido.fid}`}
                    control={control}
                    defaultValue={pedido.quantidade}
                    render={({ field }) => (
                      <NumericFormat
                        className="border border-gray-300 p-2 w-full"
                        allowNegative={false}
                        {...field}
                        onValueChange={(values) => {
                          field.onChange(values.value);
                          handleQtChange(index, values.value);
                        }}
                      />
                    )}
                  />
                </div>
                <div className="w-[10%] flex items-center">
                  <Controller
                    name={`precoA_${pedido.fid}`}
                    control={control}
                    defaultValue={pedido.precoA}
                    render={({ field }) => (
                      <NumericFormat
                        className="border p-2 w-full"
                        style={{
                          border: pedido.selectedPrice === "A" ? "2px solid #44ff44" : "1px solid #ccc",
                        }}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        {...field}
                        onValueChange={(values) => {
                          field.onChange(values.value);
                          handlePriceAChange(index, values.value);
                        }}
                      />
                    )}
                  />
                </div>
                <div className="w-[10%] flex items-center">
                  <Controller
                    name={`precoB_${pedido.fid}`}
                    control={control}
                    defaultValue={pedido.precoB}
                    render={({ field }) => (
                      <NumericFormat
                        className="border p-2 w-full"
                        style={{
                          border: pedido.selectedPrice === "B" ? "2px solid #44ff44" : "1px solid #ccc",
                        }}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        {...field}
                        onValueChange={(values) => {
                          field.onChange(values.value);
                          handlePriceBChange(index, values.value);
                        }}
                      />
                    )}
                  />
                </div>
                {/* Preço C */}
                <div className="w-[10%] flex items-center">
                  <Controller
                    name={`precoC_${pedido.fid}`}
                    control={control}
                    defaultValue={pedido.precoC}
                    render={({ field }) => (
                      <NumericFormat
                        className="border p-2 w-full"
                        style={{
                          border: pedido.selectedPrice === "C" ? "2px solid #44ff44" : "1px solid #ccc"
                        }}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale
                        allowNegative={false}
                        {...field}
                        onValueChange={(values) => {
                          field.onChange(values.value);
                          handlePriceCChange(index, values.value);
                        }}
                      />
                    )}
                  />
                </div>
                 {/* Seleção A / B / C */}
                <div className="w-[10%] flex items-center">
                  <Radio.Group
                    value={pedido.selectedPrice || "A"}
                    onChange={(e) => handleItemPriceSelection(index, e.target.value)}
                  >
                    <Radio value="A">A</Radio>
                    <Radio value="B">B</Radio>
                    <Radio value="C">C</Radio>
                  </Radio.Group>
                </div>
                <div className="w-[10%] flex items-center">
                  <Button
                    style={{ backgroundColor: "#ff4444", color: "white" }}
                    type="danger"
                    onClick={() => deleteProduct(index)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            ))}
            {/* Seletor Global */}
            <div className="flex gap-3 w-full items-center mb-3">
              <label className="block">Selecionar preço para todos os itens:</label>
              <Radio.Group value={selectedPriceType} onChange={handleGlobalPriceChange}>
                <Radio value="A">Preço A</Radio>
                <Radio value="B">Preço B</Radio>
                <Radio value="C">Preço C</Radio>
              </Radio.Group>
            </div>
          </>
        )}

        {showPedido && (
          <div className="flex gap-6 items-center">
            <label className="flex items-center gap-2">
              <input type="checkbox" {...register("aprovado")} />
              Aprovado
            </label>
            <label className="flex items-center gap-2">
              <input type="checkbox" {...register("entregue")} />
              Entregue
            </label>
            <label className="flex items-center gap-2">
              <input type="checkbox" {...register("pago")} />
              Pago
            </label>
          </div>
        )}

        {showPedido && (
           <div className="flex justify-start items-center gap-2 text-[14px]">
          <input
            type="submit"
            value="Gerar"
            className="bg-blue-default text-white p-3 cursor-pointer"
            disabled={depsLoading}
          />
          <button type="button" onClick={() => cancel()} className="border border-[#1D2E5E] rounded p-2">
            Cancelar
          </button>
        </div>
        )}
      </form>
    </div>
  );
}

export default RegisterOrcamentoForm;
